import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import Dumbo from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';
import DeviationLink from '@wix/da-shared-react/pkg/Duperbrowse/DeviationLink';
import DeviationMediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';
import { Props } from './StudioThumb';

import s from './StudioThumbMobile.scss';

const THUMB_HEIGHT = 130;

const StudioThumbMobile: FC<Props> = ({ deviation, className }) => {
  const { t } = useTranslation();
  const filetype = DeviationMediaService.getMediaFileType(deviation);
  const isDefault = filetype !== 'freeform' && deviation.isDefaultImage;
  return (
    <DeviationLink className={cn(s['root'], className)} deviation={deviation} canLinkToStash>
      <div className={s['thumb']}>
        {isDefault && (
          <div className={s['no-preview']} style={{ height: THUMB_HEIGHT }}>
            {filetype && <div className={s['extension']}>{filetype}</div>}
            {t('stash.thumbs.noPreview')}
          </div>
        )}
        {!isDefault && <Dumbo deviation={deviation} height={THUMB_HEIGHT} />}
      </div>
      <div className={s['details']}>
        <div className={s['title']}>{deviation.title}</div>
      </div>
    </DeviationLink>
  );
};
StudioThumbMobile.displayName = 'StudioThumbMobile';

export default StudioThumbMobile;
